var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRadioButtonChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.204 1.5 1.5 6.204 1.5 12C1.5 17.796 6.204 22.5 12 22.5C17.796 22.5 22.5 17.796 22.5 12C22.5 6.204 17.796 1.5 12 1.5ZM12 20.4C7.359 20.4 3.6 16.641 3.6 12C3.6 7.359 7.359 3.6 12 3.6C16.641 3.6 20.4 7.359 20.4 12C20.4 16.641 16.641 20.4 12 20.4Z",
    fill: "#7D86A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_2483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRadioButtonChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/radioButtonChecked.45460880.svg";
export { ForwardRef as ReactComponent };